import { Card } from "@/components/ui/card"
import { Skeleton } from "@/components/ui/skeleton"

export function TestimonialsSkeleton() {
  return (
    <section
        id="testimonials"
        className="bg-secondary"
    >
      <div
        className="container mx-auto px-4 max-w-6xl"
      >
        <div className="text-center space-y-4 mb-12">
            <Skeleton className="h-10 w-1/3 mx-auto" />
            <Skeleton className="h-6 w-1/2 mx-auto" />
        </div>

        <div className="space-y-16">
          <div>
            <Skeleton className="h-8 w-1/4 mx-auto mb-8" />
            <div className="w-full mx-auto">
                <div className="flex -ml-4">
                    {Array.from({ length: 3 }).map((_, index) => (
                        <div key={index} className="min-w-0 shrink-0 grow-0 basis-full md:basis-1/2 lg:basis-1/3 pl-4">
                             <div className="p-1 h-full">
                                <Card className="h-full shadow-lg overflow-hidden">
                                    <Skeleton className="aspect-video w-full" />
                                </Card>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
          </div>

          <div>
            <Skeleton className="h-8 w-1/4 mx-auto mb-8" />
            <div className="w-full mx-auto">
                <div className="flex -ml-4">
                    {Array.from({ length: 3 }).map((_, index) => (
                        <div key={index} className="min-w-0 shrink-0 grow-0 basis-full md:basis-1/2 lg:basis-1/3 pl-4">
                            <div className="p-1 h-full">
                                <Card className="h-full shadow-lg overflow-hidden">
                                    <Skeleton className="aspect-video w-full" />
                                </Card>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
